import myShopClient from './nearlive';

export async function createUnifyShop(shopData) {
	const client = await myShopClient();
	const { data } = await client.post('/api/unify/create-shop', shopData);
	return data;
}

// NEA-5838 — self-service expansion: create another store in the caller's existing
// org (shared billing inherited from `sourceShopId`; no new Clerk user/org) and
// reconcile the org's Unify subscription seat count. Returns `{ shop, seat }`.
export async function addUnifyStore(sourceShopId, shopData) {
	const client = await myShopClient();
	const { data } = await client.post(`/api/billing/add-store/${sourceShopId}`, shopData);
	return data;
}
